!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.target = null, this.originalContent = null, this.placeholder = null, 
      this.details = this.querySelector("details"), this.summary = this.querySelector("summary"), 
      this.content = this.querySelector("[data-content]"), this.underlay = this.querySelector("[data-underlay]"), 
      this.disableBodyScroll = this.hasAttribute("data-scroll-lock"), this.teleportId = `teleport-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`, 
      this.isAnimating = !1, this.boundHandleToggle = this.handleToggle.bind(this), this.boundOnSummaryClick = this.onSummaryClick.bind(this), 
      this.boundOnSummaryTouch = this.onSummaryTouch.bind(this);
    }
    connectedCallback() {
      this.details && this.summary ? (this.setAttribute("data-teleport-id", this.teleportId), 
      this.updateTarget(), this.setupCloseElements(), this.details.addEventListener("toggle", this.boundHandleToggle), 
      this.summary.addEventListener("click", this.boundOnSummaryClick), this.summary.addEventListener("touchstart", this.boundOnSummaryTouch, {
        passive: !1
      })) : console.warn("<teleport-details> must contain both <details> and <summary> elements.");
    }
    disconnectedCallback() {
      this.details && this.details.removeEventListener("toggle", this.boundHandleToggle), 
      this.summary && (this.summary.removeEventListener("click", this.boundOnSummaryClick), 
      this.summary.removeEventListener("touchstart", this.boundOnSummaryTouch));
    }
    updateTarget() {
      const t = this.getAttribute("to");
      t ? (this.target = document.querySelector(t), this.target || console.warn(`Teleport target '${t}' not found.`)) : console.warn("<teleport-details> is missing a `to` attribute for teleport target.");
    }
    setupCloseElements() {
      this.querySelectorAll("[data-close]").forEach(t => {
        t.addEventListener("click", t => {
          t.preventDefault(), this.close();
        });
      });
    }
    onSummaryTouch=t => {
      t.stopPropagation();
    };
    onSummaryClick=t => {
      t.preventDefault(), t.stopPropagation(), this.details.open ? this.close() : this.open();
    };
    handleToggle() {
      this.details.open ? (this.teleportContent(), this.disableBodyScroll && document.body.classList.add("overflow-hidden")) : (this.restoreContent(), 
      this.disableBodyScroll && document.body.classList.remove("overflow-hidden"));
    }
    teleportContent() {
      this.target && (this.originalContent || (this.originalContent = Array.from(this.details.childNodes).filter(t => !(1 === t.nodeType && "SUMMARY" === t.tagName))), 
      this.placeholder || (this.placeholder = document.createElement("div"), this.placeholder.style.display = "none", 
      this.details.appendChild(this.placeholder)), this.originalContent.forEach(t => {
        1 === t.nodeType && t.setAttribute("data-teleport-origin", this.teleportId), this.target.appendChild(t);
      }));
    }
    restoreContent() {
      this.originalContent && this.placeholder && (this.originalContent.forEach(t => {
        1 === t.nodeType && t.removeAttribute("data-teleport-origin"), this.details.insertBefore(t, this.placeholder);
      }), this.placeholder.remove(), this.placeholder = null, this.originalContent = null);
    }
    async open() {
      this.details.open || this.isAnimating || (this.isAnimating = !0, this.details.open = !0, 
      this.summary.setAttribute("aria-expanded", "true"), this.content && this.content.querySelectorAll("vanilla-slider [data-slider]").forEach(t => {
        t.scrollTo({
          left: 1,
          behavior: "instant"
        });
      }), await this.waitForAnimations(!1), this.isAnimating = !1);
    }
    async close() {
      if (!this.details.open || this.isAnimating) return;
      this.isAnimating = !0, this.summary.setAttribute("aria-expanded", "false");
      const t = await this.waitForAnimations(!0);
      if (this.details.open = !1, t.length > 0) for (const e of t) {
        const t = e.effect.target;
        t.style.animation = "none", t.offsetHeight, t.style.animation = "";
      }
      this.isAnimating = !1;
    }
    async waitForAnimations(t = !1) {
      const e = [ this.summary, this.content, this.underlay ].filter(Boolean);
      if (0 === e.length) return [];
      await new Promise(t => requestAnimationFrame(t));
      const i = e.flatMap(t => t.getAnimations());
      if (0 === i.length) return [];
      for (const e of i) t ? e.reverse() : (e.currentTime = 0, e.play());
      return await Promise.allSettled(i.map(t => t.finished)), i;
    }
    static closeById(t) {
      const e = document.querySelector(`teleport-details[data-teleport-id="${t}"]`);
      e && e.close instanceof Function && e.close();
    }
    static closeFromTeleportedContent(e) {
      const i = e.closest("[data-teleport-origin]");
      if (i) {
        const e = i.getAttribute("data-teleport-origin");
        t.closeById(e);
      }
    }
  }
  customElements.get("teleport-details") || customElements.define("teleport-details", t), 
  window.TeleportDetails = t;
}();